module.exports = __webpack_public_path__ + "img/HAPPE.b4d50542.png";